var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post_Component',{staticClass:"loading-blur",attrs:{"disable-track-views":true,"post":_vm.fakePost}})}
var staticRenderFns = []

export { render, staticRenderFns }